export const HTML_FRAGMENT = `{
    content
}`
